import { Component, OnInit } from '@angular/core';
import {ICellRendererParams} from 'ag-grid-community';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {AuthService} from '../../../services/auth.service';
import {GridService} from '../../../services/grid.service';

@Component({
  selector: 'app-sku',
  templateUrl: './sku.component.html',
  styleUrls: ['./sku.component.scss']
})
export class SkuComponent implements ICellRendererAngularComp {
  private params!: ICellRendererParams;
  public rowOnEdit: boolean = false;
  public delete: boolean = false;

  public value: string = ';'
  public user_name: string = '';
  constructor(
    private authService: AuthService,
    private gridService: GridService
  ) { }

  onDrop(event: any) {
    event.preventDefault();
    const textData = event.dataTransfer.getData('text/plain');
    console.log('textData: ', textData);
  }

  onDragOver(event: any) {
    var types = event.dataTransfer.types;
    var dragSupported = types.length;
    if (dragSupported) {
      event.dataTransfer.dropEffect = 'move';
    }
    event.preventDefault();
  }

  ngOnInit(): void {

  }

  private checkActiveGrid(gridApi: any): boolean {
    return !!(gridApi && gridApi.destroyCalled === false);
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = this.params.value;
    if (this.checkActiveGrid(this.gridService.historyGridApi)) {
      this.delete = params.data.delete;
    }
    if (this.params.data.locked && this.params.data.locked.user && (this.params.data.locked.user._id !== this.authService.currentUserValue._id)) {
      if (this.params.pinned) {
        this.user_name = this.params.data.locked?.user?.name;
        this.rowOnEdit = true;
      }
    }
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

}
